var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithdrawalSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0801 81.5781C44.1826 82.1669 45.5663 82.1631 46.6688 81.5744C76.7138 65.4344 78.8476 33.9006 78.8213 24.9344C78.8185 24.2138 78.6055 23.5096 78.2086 22.9081C77.8116 22.3067 77.2478 21.8341 76.5863 21.5481L46.3988 8.17565C45.9184 7.96388 45.3991 7.85483 44.8741 7.85547C44.349 7.85612 43.83 7.96645 43.3501 8.17939L13.3726 21.5519C12.7208 21.838 12.165 22.3054 11.7714 22.8984C11.3778 23.4915 11.163 24.1852 11.1526 24.8969C11.0251 33.8181 12.8213 65.4194 43.0801 81.5781ZM32.5276 38.5994L41.1263 47.1981L57.2251 31.0994L62.5276 36.4019L41.1263 57.8031L27.2251 43.9019L32.5276 38.5994Z",
    fill: "url(#paint0_linear_2040_53003)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2040_53003",
    x1: 91.4122,
    y1: 145.627,
    x2: -31.6959,
    y2: 122.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF725E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalSuccess);
export default __webpack_public_path__ + "static/media/withdrawal-success.2621217c82704f1f8231836c82641de8.svg";
export { ForwardRef as ReactComponent };